import React from 'react';

// Component pour le formatage des icônes et du texte
interface FormatAlteredIconsTextProps {
  children?: React.ReactNode;
}

export const FormatAlteredIconsText: React.FC<FormatAlteredIconsTextProps> = ({ children }) => {
  const text = typeof children === 'string' ? children : String(children || '');

  return (
    <span
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: text
          .replaceAll(/ {2}/g, '<br>')
          .replaceAll(
            /\[\[(.*?)\]\]/g,
            (match) => `<span class="underline font-bold">${match.replace(/[[[\]\]]+/g, '')}</span>`,
          )
          .replaceAll(/\[(.*?)\]/g, (match) => `<span class="font-bold">${match.replace(/[[\]]+/g, '')}</span>`)
          .replaceAll(/\((.*?)\)/g, (_, p1) => `<span class="italic">(${p1})</span>`)
          .replaceAll(/#(.*?)#/g, (match) => `<span class="text-primary-600">${match.replace(/#+/g, '')}</span>`)
          // .replaceAll(/#(.*?)#/g, (match) => `<span class="text-primary-600">${match.replace(/#+/g, '')}</span>`)
          .replaceAll(/{(.*?)}/g, (match) => {
            const formattedMatch = match.replace(/[{}]+/g, '').toLowerCase();

            return `<i class="fa-kit fa-altered-${formattedMatch}" aria-hidden="true" title="${formattedMatch}"></i>`;
          }),
      }}
    />
  );
};
const isUpperCase = (str: string): boolean => str === str.toUpperCase();

// Applique le formatage HTML (même logique que formatAlteredIconsText)
export const applyFormatting = (content: string): string =>
  content
    .replaceAll(/ {2}/g, '<br>')
    .replaceAll(
      /\[\[(.*?)\]\]/g,
      (match) => `<span class="underline font-bold">${match.replace(/[[[\]\]]+/g, '')}</span>`,
    )
    .replaceAll(/#(.*?)#/g, (match) => `<div class="text-primary-600 inline">${match.replace(/#+/g, '')}</div>`)
    .replaceAll(/\[(.*?)\]/g, (match) => `<span class="font-bold">${match.replace(/[[\]]+/g, '')}</span>`)
    .replaceAll(/{(.*?)}/g, (match) => {
      const formattedMatch = match.replace(/[{}]+/g, '').toLowerCase();

      return `<i class="fa-kit fa-altered-${formattedMatch}" aria-hidden="true" title="${formattedMatch}"></i>`;
    });

export const makeTextClickable = (text: string = '') => {
  let result = '';
  let i = 0;

  // DU PUR CURSOR IA. 🤖 🤖 🤖
  // Les règles pour insérer des liens dans le texte sont :
  // - Un segment cliquable se termine lorsqu'on rencontre l'un de ces caractères séparateurs :
  // - une accolade fermante }
  // - un tiret long —
  // - un deux-points :
  // - un point .
  // - Le contenu entre parenthèses ( ... ) n'est jamais cliquable (il est ignoré).
  // - Le début du texte est aussi un segment

  const isEndOfSegment = (char: string) => ['}', '—', ':', '.'].includes(char);

  // Garde le texte original avec tous les marqueurs pour l'URL
  const prepareTextForUrl = (content: string): string =>
    isUpperCase(content)
      ? content.trim().replace(/[#]/g, '').replace(/[[\]]/g, '')
      : content.trim().replace(/[{}#]/g, '').replace(/[[\]]/g, '');

  while (i < text.length) {
    let buffer = '';

    // Le contenu entre parenthèses n'est jamais cliquable
    if (text[i] === '(') {
      buffer += '(';
      i++;
      while (i < text.length && text[i] !== ')') {
        buffer += text[i];
        i++;
      }
      if (i < text.length) {
        buffer += ')';
        i++;
      }

      result += `<span class="italic">${buffer}</span>`;
      continue;
    }

    // Construit un segment jusqu'à rencontrer un séparateur ou la fin
    while (i < text.length && text[i] !== '(' && !isEndOfSegment(text[i])) {
      buffer += text[i];
      i++;
    }

    // Si on trouve un séparateur, l'inclure dans le segment
    if (i < text.length && isEndOfSegment(text[i])) {
      buffer += text[i];
      i++;
    }

    // Crée un lien cliquable pour le segment
    if (buffer.trim()) {
      const textForUrl = prepareTextForUrl(buffer);
      const encoded = encodeURIComponent(textForUrl);
      result += `<a href="/cards/market?query=${encoded}" class="hover:text-primary-700 hover:underline">${buffer}</a>`;
    }
  }

  result = applyFormatting(result);

  return (
    <span
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: result }}
    />
  );
};
